import $ from 'jquery';
import 'slick-carousel';

let sliderImage = {
    init() {
        $('.block-slider-image .slider').slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows : true,
            infinite: true,
            speed: 500,
            centerMode: true,
            slidesToShow: 1,
            centerPadding: '305px',
            responsive: [
                {
                  breakpoint: 1100,
                  settings: {
                    centerPadding: '205px',
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    centerPadding: '105px',
                  }
                },
                {
                  breakpoint: 700,
                  settings: {
                    centerPadding: '55px',
                  }
                },
            ]
        })
    }
}

export default sliderImage;
